/**
 * Single source of truth for determining if a page should be indexed by search engines.
 * Used by:
 * - next-sitemap.config.js (sitemap generation)
 * - ZeffyHead.tsx (auto-determines noIndex for meta robots tag)
 *
 * Note: This whitelist is specifically for Next.js pages (login, register, etc.).
 * Public pages like donation forms, ticketing, and organization pages are handled
 * separately via their own Head components (DonationFormHead, TicketingHead, etc.)
 * which explicitly set noIndex based on business logic.
 */
export const shouldIndexPage = (pathname) => {
    const normalizedPath = pathname.toLowerCase();
    // Only allow exact /login and /register paths (with optional locale prefix).
    // Pattern: /login, /register, /fr/login, /en-CA/register, etc.
    // We need to match paths that are exactly /login or /register, possibly prefixed by a locale segment.
    const exactPathPattern = /^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/(?:login|register)$/i;
    return exactPathPattern.test(normalizedPath);
};
